import { SellerActionTypes, All } from '../actions/sellerActions';

export interface State {
  seller: Array<any> | null;
}

const initialState: State =
{
  seller: null
}

export function sellerReducer(state = initialState, action: All): State {
  
  switch (action.type) {
    case SellerActionTypes.SELLER_SUCCESS: {
      return {
        ...state,
        seller: action.payload.seller
      };
    }
    case SellerActionTypes.SELLER_FAILURE: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
}
